import router from './router'
import store from './store'
import { Message, MessageBox } from 'element-ui'
import { getToken } from '@/utils/storage'
import { setRouter } from '@/utils/storage'
import { toLogin } from '@/utils/toLogin'
import { isMobile } from '@/utils/isMobile'

const whiteList = ['/login', '/authredirect'] // no redirect whitelist

let _router = router
router.beforeEach((to, from, next) => {
  // console.log(parent.document.getElementById('show')?parent.document.getElementById('show').contentWindow.location.href:"")
  if (
    to.name === 'login' ||
    to.name === 'filterUrl' ||
    to.name === 'changepwd' ||
    to.name === 'download' ||
    to.name === 'addEntryForm' ||
    to.name === 'entryForm' ||
    to.name === 'printEntryForm' ||
    to.name === 'retrieve' ||
    to.name === 'userInfoM' ||
    to.name === 'userInfoMForm' ||
    to.name === 'userInfoMLogin'
  ) {
    if (to.name === 'login') {
      store.dispatch('GetLogo').then(() => {})
    }
    next()
  } else {
    if (getToken()) {
      // determine if there has token
      /* has token */
      if (store.getters.userInfo == null || store.getters.menus == null) {
        // 判断当前用户是否已拉取完user_info信息
        store
          .dispatch('GetUserInfo')
          .then(res => {
            // 拉取user_info
            store.dispatch('GenerateRoutes').then(() => {
              // 根据roles权限生成可访问的路由表
              router.addRoutes(store.getters.menus)
              next({ ...to, replace: true }) // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
            })
            store.dispatch('GetConfigList').then(() => {})
          })
          .catch(() => {
            MessageBox.confirm(
              '你已被登出，可以取消继续留在该页面，或者重新登录',
              '确定登出',
              {
                confirmButtonText: '重新登录',
                cancelButtonText: '取消',
                type: 'warning'
              }
            ).then(() => {
              toLogin()
              // debugger
              // router.push('/login')
            })
          })
      } else {
        if (to.path === '/information/info') {
          if (isMobile()) {
            // 移动设备打开新闻详情页，自动跳转至移动页面
            router.push({
              path: '/information/infoShow',
              query: {
                id: to.query.id
              }
            })
          } else {
            next()
          }
        } else {
          next()
        }
      }
    } else {
      // 登录页
      toLogin(to)
      // router.push('/login')
    }
  }
})

router.afterEach(() => {})



// WEBPACK FOOTER //
// ./src/permission.js